export const move = (loc) => ({
  type: 'MOVE',
  loc
})
